import { useApi } from "../api";
import { createAdminCrudApi } from "../createAdminCrudApi";
import { CONCRETE_RESIN_ADMIN_URL } from "./concreteResinAdminUrl";
import {
  InsertChemicalAnchorBody,
  SearchChemicalAnchorsResponse,
  UpdateChemicalAnchorBody,
} from "./types/chemicalAnchors";
import { concreteResinSettingsUrl } from "./useSettings";

export const useChemicalAnchorsApi = () => {
  // The calculations' settings show the anchors too.
  const crud = createAdminCrudApi<SearchChemicalAnchorsResponse, InsertChemicalAnchorBody, UpdateChemicalAnchorBody>(
    useApi(),
    CONCRETE_RESIN_ADMIN_URL,
    "anchors",
    [concreteResinSettingsUrl],
  );

  return {
    useChemicalAnchors: crud.useSearch,
    searchChemicalAnchors: crud.search,
    insertChemicalAnchor: crud.insert,
    updateChemicalAnchor: crud.update,
    deleteChemicalAnchor: crud.remove,
    updateChemicalAnchorVisibility: crud.updateVisibility,
    updateChemicalAnchorOrder: crud.updateOrder,
  };
};

export default useChemicalAnchorsApi;
